import { TransactionType, dateDiffDays } from 'model';
import { useGetOwnLedgerBalanceQuery } from '../api/UserLedgerAPI.js';
import { useGetPublicInformationQuery } from '../api/SiteSettingsAPI.js';

interface useGetPromotionValuesProps {
	userid?: string;
	startDate?: string | null;
	endDate?: string | null;
	type?: TransactionType;
}

export const useGetPromotionValues = ({ userid, startDate, endDate, type }: useGetPromotionValuesProps) => {
	const { data: { response: userBalance } = { response: 0 } } = useGetOwnLedgerBalanceQuery(undefined);
	const { data: siteSettings } = useGetPublicInformationQuery();
	const promotionLength = (startDate && endDate && dateDiffDays(startDate, endDate) + 1) || 0;
	const totalTokenCost = Number(
		siteSettings
			? (Math.ceil(siteSettings?.promotionCostPerDay * promotionLength * 100) / 100).toFixed(0).toLocaleString()
			: 0
	);
	const balanceAfterPromotion = (userBalance || 0) - totalTokenCost;

	return {
		userBalance,
		promotionLength,
		totalTokenCost,
		balanceAfterPromotion
	};
};
